import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom'
import { StudentApi } from '../../../api/student/student.api'
import { Box, Grid, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material'
import TableRowCommon from '../../../components/table/TableRowCommon'
import { useTranslation } from 'react-i18next'
import TableCustom from '../../../components/table/tableCustom'
import FilterSelect from '../../../components/select/filterSelect'
import { dateToView } from '../../../utils/date.utils'
import ContainerButton from '../../../components/button/ContainerButton'
import { alertError, alertSuccess } from '../../../components/alert/swal'
import { unsetLoading } from '../../../store/loading/loading.slice'
import { useDispatch } from 'react-redux'

export default function StudentEducation(prop: any) {
    const { view } = prop
    const { id, id_student_educational } = useParams()
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const [head, setHead] = useState<any>()
    const [detail, setDeatil] = useState<any[]>([])
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'left', label: t("รหัสรายวิชา")
        },
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'center', label: t("ชื่อรายวิชา")
        },
        {
            id: "subject_name", disablePadding: false, width: 150, align: "center", label: t("หน่วยกิต")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 200, label: t("เกรด")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 200, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 200, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },

    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            courses_name,
            credits,
            courses_no,
            grade_courses,
            modified_name,
            id_courses,
            modified_date,
            id_student_educational_detail
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "left",
                    label: courses_no || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: courses_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: credits || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <FilterSelect
                            style={{ padding: 0 }}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setDeatil((prevData) =>
                                    prevData.map((q) =>
                                        id_student_educational_detail === q?.id_student_educational_detail
                                            ? {
                                                ...q,
                                                grade_courses: e.target.value
                                            }
                                            : q
                                    )
                                );
                            }}
                            value={grade_courses || ''}
                            labelId={"1"}
                            selectId={"1"}
                            disabled={view}
                            options={['A', 'B+', 'B', 'C+', 'C', 'D+', 'D', 'F', 'I', 'S', 'U', 'N', 'P', 'NP'].map((x) => {
                                return (
                                    <MenuItem value={x} key={x}>
                                        {x}
                                    </MenuItem>
                                )
                            })}
                        />
                    </>,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateToView(modified_date) : "-",
                },

            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const getHead = async () => {
        await StudentApi.getEducationHead(Number(id), Number(id_student_educational)).then((res) => {
            if (res.status < 300) {
                setHead(res.data?.data);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getDetail = async () => {
        await StudentApi.getEducationDetail(Number(id), Number(id_student_educational)).then((res) => {
            if (res.status < 300) {
                setDeatil(res.data?.data?.items);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        if (id) {
            getHead()
            getDetail()
        }
    }, [])
    const handleSubmit = async () => {
        const body = detail.filter((x) => x.grade_courses)?.map((item: any) => {
            return {
                "id_student_educational_detail": item?.id_student_educational_detail,
                "id_courses": item?.id_courses,
                "grade_courses": item?.grade_courses
            }
        })
        await StudentApi.updateEducationDetail(Number(id), Number(id_student_educational), body)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("บันทึก"), t("บันทึก เรียบร้อย"));
                    getDetail()
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("บันทึก"), t("บันทึก ไม่สำเร็จ"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("ข้อมูลชั้นปีที่ {{semester}} ปีการศึกษา {{academic_year}} เทอม {{term}}", { semester: location?.state?.objData?.semester, academic_year: location?.state?.objData?.academic_year, term: location?.state?.objData?.term })}
                subTitle={t("ชื่อ - นามสกุล : {{first_name}} {{last_name}} ฉายา : {{nickname}} ระดับ : {{degree}} หลักสูตร : {{faculty}}", { first_name: location?.state?.form?.student_frist_name, last_name: location?.state?.form?.student_last_name, nickname: location?.state?.form?.student_nickname, degree: i18n.language === "en" ? (location?.state?.form?.degree?.degree_name_eng || location?.state?.form?.degree?.degree_name) : location?.state?.form?.degree?.degree_name, faculty: i18n.language === "en" ? (location?.state?.form?.faculty?.faculty_name_eng || location?.state?.form?.faculty?.faculty_name) : location?.state?.form?.faculty?.faculty_name })}
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("ข้อมูลทะเบียนนักศึกษา"),
                                disabled_match: true,
                                pathName: routeName.admission.student_registration_information
                            },

                            {
                                key: "complaintSubmit",
                                name: t("ข้อมูลส่วนบุคคลนักศึกษา"),
                                pathName: routeName.admission.student_registration_information_detail.replace(':id', `${id}`)
                            },
                            {
                                key: "complaintSubmit",
                                name: t("ข้อมูลชั้นปีที่ {{semester}} ปีการศึกษา {{academic_year}} เทอม {{term}}", { semester: location?.state?.objData?.semester, academic_year: location?.state?.objData?.academic_year, term: location?.state?.objData?.term }),
                                pathName: routeName.admission.student_registration_information_detail.replace(':id', `${id}`)
                            },
                        ]}
                    />
                }

                content={
                    <div className='w-full'>

                        <Grid spacing={2} container>

                            <Grid item xs={12} md={2}>
                                <Box sx={{ border: '1px solid #5FB95D', background: '#dfffde', padding: "10px", borderRadius: '8px' }}>
                                    <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '18px' }}>GPA</Typography>
                                    <Typography sx={{ color: '#5FB95D', fontWeight: '600', fontSize: '14px', marginTop: "15px" }}>{head?.gpa || '-'}</Typography>

                                </Box>

                            </Grid>
                        </Grid>
                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={detail?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { navigate(-1) },
                                    },
                                    key: "CANCEL",
                                    label: t("ย้อนกลับ"),
                                    type: "CANCEL"
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    hidden: view,
                                    key: "SEND",
                                    label: t("ยืนยัน"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>}
            />
        </div>

    )
}
